import { render, staticRenderFns } from "./load-more.vue?vue&type=template&id=2774dc7a&scoped=true"
import script from "./load-more.vue?vue&type=script&lang=js"
export * from "./load-more.vue?vue&type=script&lang=js"
import style0 from "./load-more.vue?vue&type=style&index=0&id=2774dc7a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2774dc7a",
  null
  
)

export default component.exports